export default "__VITE_ASSET__B7THv8Vn__"